/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Identifiant d\'un élément.
 */
export const elementIdSchema = z.object({
      "id": z.string().optional()
      }).describe("Identifiant d'un élément.")